import { fonts, fontSizes, getFont, measurements, colors, designatedColors } from 'app/theme'
import css from 'styled-jsx/css'

export default css`
  .characteristic-container {
    height: 6rem;
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
    padding: 1rem;
    background-color: ${designatedColors.cardBackgroundLightIntoDarkGray};
    border-radius: ${measurements.borderRadius};
  }
`